import React, { useContext, ReactNode } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { ResultsMenuStoreContext } from "@state/context/results";
import ResultsTablesList from "./ResultsTablesList";
import ResultsTableSkeleton from "./ResultsTablesSkeleton";

export default observer(function ResultsTablesRenderer({
	children,
}: {
	children?: ReactNode;
}) {
	const store = useContext(ResultsMenuStoreContext);
	const { resultData, hasPendingRequest } = store.resultsDataStore;
	const { t } = useTranslation();

	if (hasPendingRequest) {
		return <ResultsTableSkeleton />;
	}

	if (!resultData) {
		return null;
	}

	if (resultData.length === 0) {
		return (
			<div className="card--primary__body">
				<div className="message message--base message--note">
					<i className="message__icon u-icon u-icon--lrg u-icon--info-circle u-color--sent--note" />
					<div className="message__content">
						<div className="message__text">
							{t<string>(
								"RESULTS.RESULT_CONTENT.EMPTY_STATE_TITLE"
							)}
						</div>
						<div className="message__text">
							{t<string>(
								"RESULTS.RESULT_CONTENT.EMPTY_STATE_DESCRIPTION"
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}

	return (
		<ResultsTablesList resultData={resultData}>
			{children}
		</ResultsTablesList>
	);
});
